import Socket from "./SOCKET/Socket";
import { Platform } from "./UTILS/Types";
import LOG, { log } from "../UTIL/LOG";

import Auth from "./USER/Auth";
import User from "./USER/User";
import Username from "./USER/Username";
import Files from "./FILE/Files"; 
import WebAuth from "./USER/WebAuth";
import Storage from "./UTILS/Storage";

import Friends from "./FRIENDS/Friends";
import Rooms from "./ROOMS/Rooms";
import Analytics from "./ANALYTICS/Analytics";
import Games from "./GAMES/Games";

//import Instances from "./ITEM/Instances";
import Feeds from "./POST/FEED/Feeds";
import Wallets from "./WALLET/Wallets";
import Sounds from "./AUDIO/Sounds";
import Avatars from "./AVATAR/Avatars";
import Bots from "./AVATAR/Bots";
import Email from "./CONTACTS/Email";
import Signal from "./SIGNAL/Signal";
import Haptic from "./HAPTIC/Haptic";

import Posts from "./POST/Post";

import Ads from "./ADS/Ads";
import Share from "./SHARE/Share"; 
import Contacts from "./CONTACTS/Contacts";
import MiscSystem from "./MISC/MiscSystem";
import ColyseusClient from "./COLYSEUS/ColyseusClient";

import Notification from "./NOTIFICATION/Notification";

//import Video from './VIDEO/Video';

import NFT from "./NFT/NFT";
import { ACTIONS } from "../Models/ENUM";
 
class CONQUER 
{
    public initialized  : boolean = false;
 
    public Storage      : Storage;
    public Auth         : Auth;
    public Username     : Username;
    public User         : any = {};
    public WebAuth      : WebAuth;
    public Files        : Files;
    public Friends      : Friends;
    public Rooms        : Rooms;
    public Analytics    : Analytics;
    public Games        : Games;
    public Wallets      : Wallets;
    public Sounds       : Sounds;
    public Avatars      : Avatars;
    public Bots         : Bots;
    public Email        : Email;
    public NFT          : NFT;
    public Signal       : Signal;
    public Notification : Notification;

    //public Instances    : Instances;

    public Feeds        : Feeds;

    public Share        : Share;
    public Ads          : Ads;
    public Contacts     : Contacts;
    public MiscSystem   : MiscSystem;
    public ColyseusClient: ColyseusClient;

    // public Video        : Video;

    public Haptic       : Haptic;
 
    private Socket      : Socket;
 

    private _currentPlatform: Platform;
    private disableAutoAuth: boolean = false;

    public get currentPlatform ():Platform {
        if (typeof window != 'undefined') {
            // console.log(`window platform: ${(window as any).platform} | type: ${typeof (window as any).platform} | current: ${this._currentPlatform}`);
            // let browserInfo:string = window.navigator.userAgent.toLowerCase();
            // if (browserInfo.indexOf('macintosh') >= 0 || browserInfo.indexOf('windows') >= 0 || browserInfo.indexOf('cros') >= 0 || browserInfo.indexOf('ubuntu')) {
            //     this._currentPlatform = 'Web';
            // } else if (browserInfo.indexOf('ipad') >= 0 || browserInfo.indexOf('iphone') >= 0) {
            //     this._currentPlatform = 'iOS';
            // } else if (browserInfo.indexOf('android') >= 0) {
            //     this._currentPlatform = 'Android';
            // }
            if (typeof (window as any).platform != 'undefined') {
                this._currentPlatform = (window as any).platform; 
            }
        }

        // console.log(`current platform equals None: ${this._currentPlatform == 'None'}`);
        // console.log(`current platform toString equals None: ${this._currentPlatform.toString() == 'None'}`);
            
        if (this._currentPlatform == 'None') {
            return 'Web';
        }
        // console.log(`about to return currentPlatform: ${this._currentPlatform}`);
        return this._currentPlatform;
    }
    
 
    public constructor( params?:any )
    {
        this._currentPlatform = 'None';
 
        if( params )
        {
           if( params.username )        this.User = params.username;
           if( params.disableAutoAuth ) this.disableAutoAuth = true;
        }
 
        // console.log(`[Conquer CONQUER] constructor this: ${JSON.stringify(this.User)}`);
        this.Storage    = new Storage( this );
        this.Friends    = new Friends( this );
        this.Auth       = new Auth( this );
        this.Username   = new Username( this );
        this.WebAuth    = new WebAuth( this );
        this.Files      = new Files( this );
        this.Rooms      = new Rooms( this );
        this.Socket     = new Socket( this );
        this.Analytics  = new Analytics(this);
        this.Games      = new Games( this );
       // this.Instances  = new Instances( this );
        this.Wallets    = new Wallets( this );
        this.Sounds     = new Sounds();
        this.Avatars    = new Avatars( this );
        this.Bots       = new Bots( this );
        this.Email      = new Email ( this );
        this.NFT        = new NFT( this );
        this.Signal     = new Signal();

        this.Haptic     = new Haptic();
        this.Feeds      = new Feeds( this );

        //this.Video      = new Video( this );
 
        this.Ads        = new Ads( this );
        this.Share      = new Share( this );
        this.Contacts   = new Contacts( this );
        this.MiscSystem = new MiscSystem( this );

        this.Notification = new Notification( this );

        this.ColyseusClient = new ColyseusClient( this );
    };

    public async init (): Promise<void> 
    {
        // TODO : remove test colyseus
        // await this.ColyseusClient.init();
        // return Promise.resolve();

        if (typeof window != 'undefined') {
            let w = window as any;
            try {
                if (window.parent != window.self && typeof (window.parent as any).conquerInstance != 'undefined') {
                    w.conquerInstance = (window.parent as any).conquerInstance;
                    console.log('conquer instance used from parent!');
                    return Promise.resolve();
                } else {
                    console.log('conquer instance about to be created from self!');
                }
            } catch (err) {
                console.log('conquer instance about to be created from self!');
            }
        }

        var timerCount:number = 0;
        var timerInterval:number = 10;
        var timer = setInterval(() => {
            timerCount += timerInterval;
        }, timerInterval);
        
        let version:string = "0.0.4";
        console.log(`conquer version: ${version}`);
        // console.log('conquer initializing...');
        try {
            
            // console.log(`[Conquer CONQUER] conquer.User 1: ${JSON.stringify(this.User)}`); 
            var duration = 0;
            var timerStart = 0;
            
            timerStart = timerCount;
            await this.Storage.init();
            duration = timerCount - timerStart;
            console.log(`[CONQUER init] storage: ${duration}`);
            // console.log(`[Conquer CONQUER] conquer.User 2: ${JSON.stringify(this.User)}`); 
            
            timerStart = timerCount;
            await this.WebAuth.init();
            duration = timerCount - timerStart;
            console.log(`[CONQUER init] web: ${duration}`);
            
            // console.log(`[Conquer CONQUER] conquer.User 3: ${JSON.stringify(this.User)}`); 
            timerStart = timerCount;
            await this.Socket.init();
            duration = timerCount - timerStart;
            console.log(`[CONQUER init] socket: ${duration}`);
            
            // console.log(`[Conquer CONQUER] conquer.User 4: ${JSON.stringify(this.User)}`); 
            timerStart = timerCount;
           // await this.Auth.init(this.disableAutoAuth);
            duration = timerCount - timerStart;
            console.log(`[CONQUER init] auth: ${duration}`);
            
            this.initialized    = true;

            if (typeof window != 'undefined') {
                let w = window as any;
                w.conquer = w.conquerInstance = this;
                // console.log('conquer instance created!');
            }
    
            console.log('conquer initialized!');
            clearInterval(timer);
            
            // await this.ColyseusClient.init();
        } catch (e) {
            console.log('conquer NOT initialized...');
            console.log(e);
        } finally {
            return Promise.resolve();
        }

    }
 
    public async do<T>( action:any, data?:T ): Promise<any> 
    {
        let result:any;
        try {
            let actions:ACTIONS[] = [
                ACTIONS.COLYSEUS_ECHO,
                ACTIONS.AUTH_GET,
            ];
            if (actions.indexOf(action) >= 0)
            {
                result = this.ColyseusClient.do(action, data);
            } else {
                result = this.Socket.do( action, data );
            }
        } catch (e) {
            console.log(`do [${action}] error...`);
            console.log(e);
            result = Promise.resolve();
        } finally {
            return result;
        }
    }

    public send( action:any, graphID:any, data:any ) 
    {
        let result:any;
        try {
            result = this.Socket.send( action, graphID, data );
        } catch (e) {
            console.log(`do [${action}] error...`);
            console.log(e);
            result = Promise.resolve();
        } finally {
            return result;
        }
    }
}

export default CONQUER;

let w;
if (typeof (window) !== 'undefined') {
    w = window;
}
export const _global = (w /* browser */ || global /* node */) as any
_global.CONQUER = CONQUER; 
